import styled from '@emotion/styled';
import React from 'react';
import type { Node } from 'react';

import { withSpacingStyles } from '../withSpacingStyles';

type Props = {
  className?: string,
  leftOffset?: boolean,
  minWidth: number,
  maxHeight?: string,
  children: Node | Node[],
};

export const Dropdown = withSpacingStyles(
  ({ className, leftOffset, minWidth, maxHeight, children, ...rest }: Props) => {
    return (
      <DropdownWrapper
        className={className}
        leftOffset={leftOffset}
        minWidth={minWidth}
        maxHeight={maxHeight}
        {...rest}
      >
        {children}
      </DropdownWrapper>
    );
  }
);

const DropdownWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 98%;
  background-color: ${({ theme }) => theme.color.white};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  border: ${({ theme }) => theme.stroke.light};
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: ${({ theme }) => theme.boxShadow.small};
  text-align: center;
  z-index: ${({ theme }) => theme.positioning.modalOverlay};
  top: 42px;

  ${({ maxHeight }) =>
    maxHeight &&
    `
    max-height: ${maxHeight};
    overflow: auto;
  `}

  @media (${({ theme }) => theme.breakpoint.tablet}) {
    width: auto;
    min-width: ${({ minWidth }) => `${minWidth}px`};
    margin-right: ${({ theme }) => theme.margins.md};
    left: ${({ leftOffset }) => leftOffset && 0};
    top: 38px;
  }
`;
